import { render, staticRenderFns } from "./AccommodationItem.vue?vue&type=template&id=17075737&scoped=true"
import script from "./AccommodationItem.vue?vue&type=script&lang=js"
export * from "./AccommodationItem.vue?vue&type=script&lang=js"
import style0 from "./AccommodationItem.vue?vue&type=style&index=0&id=17075737&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17075737",
  null
  
)

export default component.exports